import create from 'zustand';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const useAuthStore = create((set) => ({
  user: null,
  token: localStorage.getItem('token'),
  isLoading: false,
  // if there's a saved token we must verify it before any route guard can trust `user` —
  // otherwise a refresh briefly sees user=null, gets bounced to /login, then home once
  // fetchProfile resolves, instead of staying on the page that was actually requested
  authChecked: !localStorage.getItem('token'),
  error: null,

  login: async (email, password) => {
    set({ isLoading: true, error: null });
    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        email,
        password,
      });
      const { token, user } = response.data;
      localStorage.setItem('token', token);
      set({ user, token, isLoading: false });
      return { success: true };
    } catch (error) {
      set({
        error: error.response?.data?.message || 'Login failed',
        isLoading: false,
      });
      return { success: false };
    }
  },

  register: async (fullName, email, password, language) => {
    set({ isLoading: true, error: null });
    try {
      const response = await axios.post(`${API_URL}/auth/register`, {
        fullName,
        email,
        password,
        language,
      });
      const { token, user } = response.data;
      localStorage.setItem('token', token);
      set({ user, token, isLoading: false });
      return { success: true };
    } catch (error) {
      set({
        error: error.response?.data?.message || 'Registration failed',
        isLoading: false,
      });
      return { success: false };
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    set({ user: null, token: null });
  },

  fetchProfile: async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      set({ authChecked: true });
      return;
    }

    try {
      const response = await axios.get(`${API_URL}/auth/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      set({ user: response.data, authChecked: true });
    } catch (error) {
      console.error('Failed to fetch profile:', error);
      // saved token is invalid/expired — clear it so guarded routes fall through to /login
      localStorage.removeItem('token');
      set({ user: null, token: null, authChecked: true });
    }
  },
}));
